import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent,
  Input,
  LinearProgress,
  Button
} from '@material-ui/core';
import { store } from 'src/_helpers';
import Page from 'src/components/Page';
import DropZone from 'react-dropzone';
import axios from 'axios';
const Papa = require('papaparse');

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  dropZone: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '50px 20px',
    borderWidth: '2px',
    borderRadius: '2px',
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
  }
}));

const UploadFile = () => {
  // const [selectedFile, setselectedFile] = useState();
  const classes = useStyles();
  const [customers, setCustomer] = useState({});
  const [selectedFile, setselectedFile] = useState(null);
  const [loaded, setloaded] = useState(0);
  let { user } = store.getState().authentication;
  useEffect(() => {
    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ title: 'React POST Request Example' })
    // };
    //  fetch(`http://localhost:8080/v10/user?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2MDc1MDgzMDgsImV4cCI6MTYwNzUxMTkwOH0.MLYhSmJP_Ub7dsK0g1RXkqAO9mmTv6LLZAUQ19wv82I&type=user`)
    //   .then((response) => response.json())
    //   .then((data) => {
    //     setCustomer(data.results[0])
    //     console.log("data", data);
    //   });
  }, []);
  const el = useRef();
  var onChangeHandler = event => {
    // const file = event.target.files[0]; // accessing file
    // console.log(file);
    // setselectedFile(file);
    // setloaded(0);
    // Papa.parse(file, {
    //   header: true,
    //   complete: function(results) {
    //   }
    // });
  };

  const onSubmit = () => {
    const data = new FormData();
    data.append('tokens', user?.token);
    data.append('file', selectedFile);
    axios
      .post(process.env.REACT_APP_BASE_URL`/v10/tax/all`, data, {
        onUploadProgress: ProgressEvent => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        }
      })
      .then(res => {
        // then print response status
        console.log('res', res);
        // toast.success('upload success');
      })
      .catch(err => {
        console.log('err', err);
      });
  };

  function handleResponse(response) {
    return response.text().then(text => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
          // auto logout if 401 response returned from api
          // logout();
          // location.reload(true);
        }

        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      return data;
    });
  }

  return (
    <Page className={classes.root} title="Upload CSV File">
      <Container maxWidth={false}>
        <Card>
          <CardContent>
            {/* <Toolbar /> */}
            <Box mt={3}>
              <DropZone
                onDrop={onChangeHandler}
                type="file"
                name="file"
                ref={el}
                // getJson={res => console.log(res)}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p className={classes.dropZone}>
                        Drag 'n' drop some files here, or click to select files
                      </p>
                    </div>
                  </section>
                )}
              </DropZone>
            </Box>
            <LinearProgress
              variant="determinate"
              max="100"
              color="success"
              value={loaded}
            >
              {Math.round(loaded, 2)}%
            </LinearProgress>
            <Box mt={3}>
              <Button
                onClick={onSubmit}
                variant="contained"
                color="primary"
                style={{ width: '100%' }}
              >
                UPLOAD FILE
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default UploadFile;
{
  /* <input type="file" name="file" onChange={this.onChangeHandler} />
<button
  type="button"
  class="btn btn-success btn-block"
  onClick={this.onClickHandler}
>
  Upload
</button> */
}
// return (
//   <Page className={classes.root} title="Upload CSV File">
//     <Container maxWidth={false}>
//       <Card>
//         <CardContent>
//           {/* <Toolbar /> */}
//           <Box mt={3}>
//             <DropZone
//               onDrop={onChangeHandler}
//               // getJson={res => console.log(res)}
//             >
//               {({ getRootProps, getInputProps }) => (
//                 <section>
//                   <div {...getRootProps()}>
//                     <input {...getInputProps()} />
//                     <p className={classes.dropZone}>
//                       Drag 'n' drop some files here, or click to select files
//                     </p>
//                   </div>
//                 </section>
//               )}
//             </DropZone>

//             {/* {({ getRootProps, getInputProps }) => (
//                 <section>
//                   <div {...getRootProps()}>
//                     <input {...getInputProps()} />
//                     <p className={classes.dropZone}>
//                       Drag 'n' drop some files here, or click to select files
//                     </p>
//                   </div>
//                 </section>
//               )} */}
//             {/* </input> */}
//           </Box>
//           <LinearProgress
//             variant="determinate"
//             max="100"
//             color="success"
//             value={loaded}
//           >
//             {Math.round(loaded, 2)}%
//           </LinearProgress>
//           <Box mt={3}>
//             <Button
//               onClick={onSubmit}
//               variant="contained"
//               color="primary"
//               style={{ width: '100%' }}
//             >
//               UPLOAD FILE
//             </Button>
//           </Box>
//         </CardContent>
//       </Card>
//     </Container>
//   </Page>
// );
// };
